module.exports = __webpack_public_path__ + "img/cross-inverse.46980de8.svg";